import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* abeam 横向*/
import Abeam from "@/views/abeam/Layout";

export const routerMap = {
  Layout: () => Layout,
};
export const constantRouterMap = [
  //路由重定向
  {
    path: "/",
    redirect: "/home",
  },
  /* {
    path: '/',
    redirect: "/login"
  }, */
  // 没有下拉菜单，页面卸载children中
  {
    path: "/homeView",
    component: Abeam,
    redirect: "home",
    name: "homeView",
    alwaysShow: true,
    meta: {
      title: "Home", //标题
      title1: "首页",
      icon: "home", //图标
      // img: require('@/assets/logo.png')
    },
    children: [
      {
        path: "/home",
        component: () => import("@/views/pages/home"),
        name: "home",
        meta: {
          title: "Home",
          title1: "首页",
          img: require("@/assets/logo.png"),
        },
      },
    ],
  },
  {
    path: "/GenomeView",
    component: Abeam,
    redirect: "Genome",
    name: "GenomeView",
    alwaysShow: true,
    meta: {
      title: "Genome", //标题
      title1: "工具",
      icon: "Genome", //图标
    },
    children: [
      {
        path: "/GenomeData",
        component: () => import("@/views/pages/Genome/GenomeData"),
        name: "Genome Data",
        meta: { title: "Genome Data", title1: "基因组浏览器", icon: "browse" },
      },
      {
        path: "/JBrowse",
        component: () => import("@/views/pages/Genome/Jbrowse"),
        name: "JBrowse",
        meta: { title: "JBrowse", title1: "基因组浏览器", icon: "browse" },
      },

      {
        path: "/Synteny",
        component: () => import("@/views/pages/Genome/Synteny"),
        name: "Genome Synteny",
        meta: {
          title: "Genome Synteny",
          title1: "基因组浏览器",
          icon: "browse",
        },
      },
    ],
  },
  {
    path: "/PopulationView",
    component: Abeam,
    redirect: "Population",
    name: "PopulationView",
    alwaysShow: true,
    meta: {
      title: "Population", //标题
      title1: "下载", //标题
      icon: "gwas", //图标
    },
    children: [
      {
        path: "/PopulationData",
        component: () => import("@/views/pages/Variome/PopulationData"),
        name: "Population Data",
        meta: { title: "Population Data", title1: "下载" },
      },
      {
        path: "/PopulationStructure",
        component: () => import("@/views/pages/Variome/PopulationStructure"),
        name: "Population Structure",
        meta: { title: "Population Structure", title1: "下载" },
      },
      {
        path: "/Variome",
        component: () => import("@/views/pages/Variome/Variome"),
        name: "Variome",
        meta: { title: "Variome", title1: "下载" },
      },
      {
        path: "/SelectionSignal",
        component: () => import("@/views/pages/Variome/index"),
        name: "Selection Signal",
        redirect: "/pi",
        meta: { title: "Selection Signal", title1: "下载" },
        children: [
          {
            path: "/pi",
            component: () => import("@/views/pages/Variome/pi"),
            name: "π",
            meta: { title: "π", title1: "下载" },
          },
          {
            path: "/fst",
            component: () => import("@/views/pages/Variome/fst"),
            name: "Fst",
            meta: { title: "Fst", title1: "下载" },
          },
          /* {
            path: '/xpclr',
            component: () => import('@/views/pages/Variome/xpclr'),
            name: 'xpclr',
            meta: { title: 'xpclr', title1: '下载', }
          }, */
        ],
      },
    ],
  },
  {
    path: "/TranscriptomicsView",
    component: Abeam,
    redirect: "Transcriptomics",
    name: "TranscriptomicsView",
    alwaysShow: true,
    meta: {
      title: "Transcriptome", //标题
      title1: "下载", //标题
      icon: "gwas", //图标
    },
    children: [
      {
        path: "/eFP",
        component: () => import("@/views/pages/Transcriptomics/Overview"),
        name: "eFP",
        meta: { title: "eFP", title1: "下载" },
      },
      {
        path: "/coexpression",
        component: () => import("@/views/pages/Transcriptomics/coexpression"),
        name: "Co-Expression",
        meta: { title: "Co-Expression", title1: "下载" },
      },
      {
        path: "/MotifEnrichment",
        component: () =>
          import("@/views/pages/Transcriptomics/MotifEnrichment"),
        name: "Motif Enrichment",
        meta: {
          title: "Motif Enrichment",
          title1: "基因组浏览器",
          icon: "browse",
        },
      },
      {
        path: "/MotifPrediction",
        component: () =>
          import("@/views/pages/Transcriptomics/MotifPrediction"),
        name: "Motif Prediction",
        meta: {
          title: "Motif Prediction",
          title1: "基因组浏览器",
          icon: "browse",
        },
      },
      {
        path: "/TranscriptFactor",
        component: () =>
          import("@/views/pages/Transcriptomics/TranscriptionFactor"),
        name: "Transcription Factors",
        meta: {
          title: "Transcription Factors",
          title1: "基因组浏览器",
          icon: "browse",
        },
      },
      {
        path: "/DifferentialExpressionAnalysis",
        component: () =>
          import(
            "@/views/pages/Transcriptomics/DifferentialExpressionAnalysis"
          ),
        name: "Differential expression analysis",
        meta: {
          title: "Differential expression analysis",
          title1: "基因组浏览器",
          icon: "browse",
        },
      },
    ],
  },
  /*  {
    path: "/MutationView",
    component: Abeam,
    redirect: "Mutation",
    name: "MutationView",
    alwaysShow: true,
    meta: {
      title: "Mutation library", //标题
      title1: "下载", //标题
      icon: "gwas", //图标
    },
    children: [
      {
        path: "/Overview",
        component: () => import("@/views/pages/Mutation/Overview"),
        name: "Overview",
        meta: { title: "Overview", title1: "下载" },
      },
      {
        path: "/Variations",
        component: () => import("@/views/pages/Mutation/Variations"),
        name: "Variations",
        meta: { title: "Variations", title1: "下载" },
      },
      {
        path: "/Seed-request",
        component: () => import("@/views/pages/Mutation/Seed-request"),
        name: "Seed request",
        meta: { title: "Seed request", title1: "下载" },
      },
    ],
  }, */
  {
    path: "/ToolsView",
    component: Abeam,
    redirect: "Tools",
    name: "ToolsView",
    alwaysShow: true,
    meta: {
      title: "Tools", //标题
      title1: "下载", //标题
      icon: "tools", //图标
    },
    children: [
      {
        path: "/Blast",
        component: () => import("@/views/pages/tools/Blast"),
        name: "BLAST",
        meta: { title: "BLAST", title1: "多序列比对", icon: "msa" },
      },
      {
        path: "/IDConversion",
        component: () => import("@/views/pages/tools/IDConversion"),
        name: "IDConverter",
        meta: { title: "IDConverter", title1: "多序列比对", icon: "msa" },
      },
      {
        path: "/Sequence",
        component: () => import("@/views/pages/tools/Sequence"),
        name: "GetSequence",
        meta: { title: "GetSequence", title1: "同源基因", icon: "go" },
      },
      {
        path: "/MSA",
        component: () => import("@/views/pages/tools/MSA"),
        name: "Multiple Sequence Alignment",
        meta: {
          title: "Multiple Sequence Alignment",
          title1: "多序列比对",
          icon: "msa",
        },
      },
      {
        path: "/Enrichment",
        component: () => import("@/views/pages/tools/Enrichment"),
        name: "GO & KEGG Enrichment",
        meta: {
          title: "GO & KEGG Enrichment",
          title1: "KEGG富集",
          icon: "jiyinxin",
        },
      },
      {
        path: "/Primer",
        component: () => import("@/views/pages/tools/Primer"),
        name: "PrimerDesigner",
        meta: { title: "PrimerDesigner", title1: "同源基因", icon: "go" },
      },
      {
        path: "/CRISPR",
        component: () => import("@/views/pages/tools/CRISPR"),
        name: "CRISPR/Cas9",
        meta: { title: "CRISPR/Cas9", title1: "同源基因", icon: "go" },
      },
      {
        path: "/TransposableElement",
        component: () => import("@/views/pages/tools/TE"),
        name: "Transposable Element",
        meta: {
          title: "Transposable Element",
          title1: "基因组浏览器",
          icon: "browse",
        },
      },
      {
        path: "/GFFviewer",
        component: () => import("@/views/pages/tools/StructureAnnotation"),
        name: "GFFviewer",
        meta: { title: "GFFviewer", title1: "基因组浏览器", icon: "browse" },
      },
      {
        path: "/ReverseComplement",
        component: () => import("@/views/pages/tools/ReferenceSequence"),
        name: "Reverse Complement",
        meta: {
          title: "Reverse Complement",
          title1: "基因组浏览器",
          icon: "browse",
        },
      },

      /* {
        path: '/toolOrthologousGene',
        component: () => import('@/views/pages/tools/OrthologousGene'),
        name: 'Orthologous Gene',
        meta: { title: 'Orthologous Gene', title1: '基因组浏览器', icon: 'browse' }
      }, */
    ],
  },

  {
    path: "/DownloadView",
    component: Abeam,
    redirect: "Download",
    name: "DownloadView",
    alwaysShow: true,
    meta: {
      title: "Download", //标题
      title1: "联系我们",
      icon: "Download", //图标
    },
    children: [
      {
        path: "/download",
        component: () => import("@/views/pages/download"),
        name: "Download",
        meta: { title: "Download", title1: "下载" },
      },
    ],
  },
  {
    path: "/AboutView",
    component: Abeam,
    redirect: "About",
    name: "AboutView",
    alwaysShow: true,
    meta: {
      title: "About", //标题
      title1: "联系我们",
      icon: "About", //图标
    },
    children: [
      {
        path: "/Manual",
        component: () => import("@/views/pages/Manual"),
        name: "Manual",
        meta: { title: "Manual", title1: "联系我们" },
      },
      {
        path: "/Contact",
        component: () => import("@/views/pages/Contact"),
        name: "Contact us",
        meta: { title: "Contact us", title1: "联系我们" },
      },
    ],
  },
  {
    path: "/detail",
    component: Abeam,
    redirect: "detail",
    name: "detail",
    alwaysShow: false,
    meta: {
      title: "detail", //标题
      title1: "详情页", //标题
      icon: "home",
    },
    children: [
      {
        path: "/detail",
        component: () => import("@/views/pages/detail"),
        name: "detail",
        meta: { title: "detail", title1: "详情页" },
      },
      {
        path: "/MD5",
        component: () => import("@/views/pages/MD5"),
        name: "detail",
        meta: { title: "detail", title1: "详情页" },
      },
    ],
  },
  // 有下拉菜单，写在children中
  /*  {
     path: '/home1',
     component:Abeam,
     // redirect: 'area',
     name: 'anti_channel',
     alwaysShow: true,
     meta: {
       title: '其他页面',//标题
       icon: 'home'//图标
     },
     children: [
       {
         path: '/home1/mm',
         component: () => import('@/views/login/index'),
         name: 'mm',
         meta: { title: '测试2', }
       },
       {
         path: '/home1/ceshi',
         component: () => import('@/views/login/index'),
         name: 'ceshi',
         meta: { title: '测试3', }
       },
     ]
   } */

  // {
  //	 path: '/404',
  //	 component: () => import('@/views/errorPage/404'),
  //	 hidden: true
  // },
  // {
  //	 path: '/401',
  //	 component: () => import('@/views/errorPage/401'),
  //	 hidden: true
  // }
];

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: constantRouterMap,
});

export const asyncRouterMap = [
  /** When your routing table is too long, you can split it into small modules**/
];
